import React from 'react';

interface Attainment {
  id: string | number;
  label: string;
}

interface ExecutorSkillsCellProps {
  row: {
    availableAttainments?: Attainment[];
    unavailableAttainments?: Attainment[];
  };
}

export const ExecutorSkillsCell: React.FC<ExecutorSkillsCellProps> = ({
  row
}) => {
  const { availableAttainments = [], unavailableAttainments = [] } = row;

  const hasSkills =
    availableAttainments.length > 0 || unavailableAttainments.length > 0;

  if (!hasSkills) {
    return (
      <div className="flex items-center justify-center text-gray-500 italic text-sm py-2">
        Плановые работы не выбраны или навыки не требуются
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-1">
      {availableAttainments.map((a) => (
        <span
          key={a.id}
          style={{
            backgroundColor: '#c6f6d5',
            color: '#22543d',
            padding: '2px 6px',
            borderRadius: '10px',
            fontSize: '12px'
          }}
        >
          {a.label}
        </span>
      ))}
      {unavailableAttainments.map((u) => (
        <span
          key={u.id}
          style={{
            backgroundColor: '#fed7d7',
            color: '#742a2a',
            padding: '2px 6px',
            borderRadius: '10px',
            fontSize: '12px'
          }}
        >
          {u.label}
        </span>
      ))}
    </div>
  );
};

export default ExecutorSkillsCell;
